(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hf-coll-cats"] && !Shopify.designMode) return;
  try {
    /* The category you are in is scrolled into view when the row scrolls sideways (phone and tablet) */
  (function () {
    function show() {
      document.querySelectorAll('.hf-coll-cats__list').forEach(function (list) {
        var on = list.querySelector('[aria-current]');
        if (!on) return;
        var l = list.getBoundingClientRect(), c = on.getBoundingClientRect();
        if (c.left < l.left || c.right > l.right) list.scrollLeft += c.left - l.left - 12;
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', show); else show();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hf-notify-sms"] && !Shopify.designMode) return;
  try {
    (function () {
    var PHONE_DIGITS = /\d/g;

    function init(box) {
      if (box.dataset.hfNotifyInit) return;
      box.dataset.hfNotifyInit = '1';
      var root = box.closest('[data-hf-product]') || document.body;
      var form = box.querySelector('[data-hf-notify-form]');
      var input = form.querySelector('input[name="phone"]');
      var consent = form.querySelector('[data-hf-notify-consent]');
      var consentText = box.querySelector('[data-hf-notify-consent-text]');
      var honeypot = form.querySelector('input[name="website"]');
      var btn = form.querySelector('button[type="submit"]');
      var msg = box.querySelector('[data-hf-notify-msg]');
      var done = box.querySelector('[data-hf-notify-done]');
      var doneText = box.querySelector('[data-hf-notify-done-text]');
      var data = {};
      try { data = JSON.parse(box.querySelector('[data-hf-notify-data]').textContent); } catch (err) {}
      var strings = data.strings || {};
      var variantsEl = root.querySelector('[data-hf-variants]');
      var variants = [];
      try { variants = variantsEl ? JSON.parse(variantsEl.textContent) : []; } catch (err) {}
      var jumps = Array.prototype.slice.call(root.querySelectorAll('[data-hf-notify-jump]'));
      var current = null;
      var busy = false;

      function storeKey(v) { return 'hf-notify:' + (v ? v.id : ''); }
      function remembered(v) { try { return !!localStorage.getItem(storeKey(v)); } catch (err) { return false; } }
      function remember(v) { try { localStorage.setItem(storeKey(v), String(Date.now())); } catch (err) {} }
      function forget(v) { try { localStorage.removeItem(storeKey(v)); } catch (err) {} }

      // Same rule as the product form in hf-theme.js: the variant whose options match the checked radios
      function currentVariant() {
        if (!variants.length) return null;
        if (variants.length === 1) return variants[0];
        var opts = Array.prototype.map.call(root.querySelectorAll('[data-hf-option]'), function (group) {
          var checked = group.querySelector('input:checked');
          return checked ? checked.value : null;
        });
        for (var i = 0; i < variants.length; i++) {
          var ok = true;
          for (var j = 0; j < opts.length; j++) { if (opts[j] !== null && variants[i].options[j] !== opts[j]) { ok = false; break; } }
          if (ok) return variants[i];
        }
        return null;
      }

      function say(text, ok) {
        msg.textContent = text || '';
        msg.classList.toggle('is-ok', !!ok);
      }
      function showDone(text) {
        doneText.textContent = text;
        form.hidden = true;
        done.hidden = false;
      }
      function showForm() {
        form.hidden = false;
        done.hidden = true;
        say('');
      }

      function sync() {
        var v = currentVariant();
        var changed = !current || !v || current.id !== v.id;
        current = v;
        var show = !!(v && !v.available);
        box.hidden = !show;
        root.classList.toggle('is-notify', show);
        if (!changed) return;
        if (show && remembered(v)) showDone(strings.duplicate);
        else showForm();
      }

      function phoneOk(value) {
        var digits = (value.match(PHONE_DIGITS) || []).length;
        return digits >= 8 && digits <= 15 && /^[\d\s+()./-]+$/.test(value.trim());
      }

      function codeText(code) {
        return strings[code] || strings.error;
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (busy || !current) return;
        var phone = input.value.trim();
        input.removeAttribute('aria-invalid');
        consent.closest('.hf-check').classList.remove('is-invalid');
        if (!phoneOk(phone)) {
          input.setAttribute('aria-invalid', 'true');
          say(strings.invalid_phone);
          input.focus();
          return;
        }
        if (!consent.checked) {
          consent.closest('.hf-check').classList.add('is-invalid');
          say(strings.consent_required);
          consent.focus();
          return;
        }
        var endpoint = box.getAttribute('data-endpoint');
        var variant = current;
        var body = {
          phone: phone,
          country: data.country,
          variant_id: String(variant.id),
          product_id: String(data.product_id),
          product_handle: data.product_handle,
          product_title: data.product_title,
          variant_title: variant.title === 'Default Title' ? null : variant.title,
          product_url: data.product_url,
          locale: data.locale,
          consent: true,
          consent_text: consentText.textContent.trim(),
          page_url: window.location.href,
          website: honeypot.value
        };
        busy = true;
        btn.classList.add('is-loading');
        btn.setAttribute('aria-busy', 'true');
        say(strings.sending, true);
        fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
          .then(function (res) {
            return res.json().catch(function () { return {}; }).then(function (json) { return { status: res.status, json: json }; });
          })
          .then(function (r) {
            var code = r.json && r.json.code;
            if (r.status >= 200 && r.status < 300 && r.json && r.json.ok) {
              remember(variant);
              input.value = '';
              consent.checked = false;
              showDone(code === 'duplicate' ? strings.duplicate : strings.saved);
              return;
            }
            if (code === 'invalid_phone') { input.setAttribute('aria-invalid', 'true'); input.focus(); }
            say(codeText(code));
          })
          .catch(function () { say(strings.error); })
          .then(function () {
            busy = false;
            btn.classList.remove('is-loading');
            btn.removeAttribute('aria-busy');
          });
      });

      box.querySelector('[data-hf-notify-again]').addEventListener('click', function () {
        forget(current);
        showForm();
        input.focus();
      });

      jumps.forEach(function (jump) {
        jump.addEventListener('click', function () {
          var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          box.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'center' });
          var target = form.hidden ? box.querySelector('[data-hf-notify-again]') : input;
          setTimeout(function () { target.focus({ preventScroll: true }); }, still ? 0 : 400);
        });
      });

      // The product form re-renders on "change" (hf-theme.js); read the new variant after it
      root.addEventListener('change', function (e) {
        if (box.contains(e.target)) return;
        setTimeout(sync, 0);
      });
      sync();
    }

    function initAll(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('[data-hf-notify]'), init);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
    else initAll();
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hf-product-intro"] && !Shopify.designMode) return;
  try {
    (function () {
    function target() { return document.querySelector('.hf-details'); }
    function init() {
      if (!target()) return;
      document.querySelectorAll('[data-hf-more]').forEach(function (a) { a.hidden = false; });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-hf-more]');
      var box = a && target();
      if (!box) return;
      e.preventDefault();
      var first = box.querySelector('details');
      if (first) first.open = true;
      box.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hf-recipe-filters"] && !Shopify.designMode) return;
  try {
    (function () {
    function init(root) {
      if (root.dataset.hfInit) return;
      root.dataset.hfInit = '1';
      var cards = Array.prototype.slice.call(document.querySelectorAll('[data-hf-rcard]'));
      var countEl = root.querySelector('[data-hf-rf-count]');
      var emptyEl = root.querySelector('[data-hf-rf-empty]');
      var params = new URLSearchParams(window.location.search);
      var state = { heat: params.get('lyutivina') || '', time: params.get('vreme') || '' };
      var tplOne = root.getAttribute('data-hf-rf-one') || '[n]';
      var tplMany = root.getAttribute('data-hf-rf-many') || '[n]';
      function countText(n) { return (n === 1 ? tplOne : tplMany).replace('[n]', n); }
      function matches(card) {
        var m = card.querySelector('[data-hf-rmeta]');
        if (!m) return !state.heat && !state.time;
        var heat = m.getAttribute('data-heat');
        var time = parseInt(m.getAttribute('data-time'), 10) || 0;
        if (state.heat && heat !== state.heat) return false;
        if (state.time) {
          var t = parseInt(state.time, 10);
          if (!time) return false;
          if (t <= 30 && time > t) return false;
          if (t > 30 && time <= 30) return false;
        }
        return true;
      }
      function render() {
        var shown = 0;
        cards.forEach(function (c) { var ok = matches(c); c.hidden = !ok; if (ok) shown++; });
        root.querySelectorAll('[data-hf-rf]').forEach(function (b) {
          b.setAttribute('aria-pressed', String(b.getAttribute('data-value') === state[b.getAttribute('data-hf-rf')]));
        });
        if (countEl) countEl.textContent = countText(shown);
        if (emptyEl) emptyEl.hidden = shown > 0;
        var pager = document.querySelector('.hf-results .hf-pagination');
        if (pager) pager.hidden = !!(state.heat || state.time);
      }
      function save() {
        var p = new URLSearchParams(window.location.search);
        if (state.heat) p.set('lyutivina', state.heat); else p.delete('lyutivina');
        if (state.time) p.set('vreme', state.time); else p.delete('vreme');
        var q = p.toString();
        history.replaceState(null, '', window.location.pathname + (q ? '?' + q : '') + window.location.hash);
      }
      root.addEventListener('click', function (e) {
        var b = e.target.closest('[data-hf-rf]');
        if (b) { state[b.getAttribute('data-hf-rf')] = b.getAttribute('data-value'); render(); save(); return; }
        if (e.target.closest('[data-hf-rf-reset]')) { state.heat = ''; state.time = ''; render(); save(); }
      });
      render();
    }
    function initAll() { document.querySelectorAll('[data-hf-rfilters]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hf-recipe-meta"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.hfAddMany) return;
    window.hfAddMany = true;
    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-hf-add-many]');
      if (!btn || !window.HF || !HF.cart) return;
      e.preventDefault();
      var items = btn.getAttribute('data-hf-add-many').split(',').map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; }).filter(function (it) { return it.id; });
      if (!items.length || btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      HF.cart.add(items)
        .then(function () { return HF.cart.refresh(); })
        .then(function () { return HF.openCart ? HF.openCart() : false; })
        .then(function (opened) { if (!opened && HF.toast) HF.toast('<span>' + esc(btn.getAttribute('data-hf-title')) + '</span>'); })
        .catch(function (err) { if (HF.toast) HF.toast(esc((err && err.message) || btn.getAttribute('data-hf-error') || 'Error'), { error: true }); })
        .then(function () { btn.classList.remove('is-loading'); });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hf-recipe-photo"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.hfRecipeSpots) return;
    window.hfRecipeSpots = true;
    function closeAll(except) {
      document.querySelectorAll('[data-hf-spot][open]').forEach(function (d) { if (d !== except) d.open = false; });
    }
    document.addEventListener('toggle', function (e) {
      var d = e.target;
      if (d.matches && d.matches('[data-hf-spot]') && d.open) closeAll(d);
    }, true);
    document.addEventListener('click', function (e) {
      var close = e.target.closest('[data-hf-spot-close]');
      if (close) { e.preventDefault(); close.closest('[data-hf-spot]').open = false; return; }
      if (!e.target.closest('[data-hf-spot]')) closeAll(null);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(null); });
    document.addEventListener('hf:cart', function () { closeAll(null); });
  })();
  } catch(e) { console.error(e); }
})();

})();
